// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CONTENEDOR GENERAL */

.clientes-container {
    background-color: var(--app-fondo);
    color: var(--texto-principal);
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    font-family: var(--font-principal);

}

/* MAIN */
.clientes-main {
    padding: 32px;
    flex: 1 1;
    margin: 0px 80px;
}

/* FILTROS */
.toolbar-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap; 
    gap: 20px;       
    margin-bottom: 25px;
    
    background: var(--bg-card); 
    
    padding: 20px;
    border-radius: 12px;
    box-shadow: var(--sombra-card);
    border: 1px solid var(--color-borders);
}

/* Search Wrapper */
.search-wrapper {
    position: relative;
    flex: 1 1; 
    min-width: 280px;
}

.search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--color-gray-text);
    font-size: 1.2rem;
}

.search-input {
    width: 100%; 
    padding: 10px 12px 10px 45px;
    border: 1px solid var(--color-borders); 
    background-color: var(--bg-input); 
    color: var(--texto-principal);
    border-radius: 8px;
    font-size: 14px; 
    outline: none;
    transition: all 0.2s;
}

.search-input:focus {
    border-color: var(--primary-blue);
    box-shadow: 0 0 0 3px rgba(67, 56, 202, 0.1);
}

/* Filter - Order Wrapper */
.filter-order-wrapper {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    flex-shrink: 0; 
}

.filter-select {
    padding: 10px 12px;
    border: 1px solid var(--color-borders);
    border-radius: 8px;
    background-color: var(--bg-input);
    color: var(--texto-principal);
    cursor: pointer;
    outline: none;
    font-size: 14px;
    width: auto; 
    min-width: 150px; 
    appearance: none;
}

.filter-select:focus {
    border-color: var(--primary-blue);
}

/* TABLA */

.tabla-container {
    border-radius: 12px;
    box-shadow: var(--sombra-card);
    overflow: hidden;
}
.clientes-tabla tr {
    background-color: var(--bg-card);
}
.clientes-tabla {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
}

.clientes-tabla th,
.clientes-tabla td {
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 12px 16px;
    border-bottom: 1px solid var(--color-light-bg);
}

/* Encabezados */
.clientes-tabla th {
    background-color: var(--bg-card);
    color: var(--primary-blue);
    text-transform: uppercase;
    font-size: 20px;
    font-weight: 600;
}



/* Botones de acción */
.accion-boton {
    background: none;
    border: none;
    color: var(--primary-blue);
    cursor: pointer;
    font-size: 20px;
    transition: opacity .2s;
}

.accion-boton:hover {
    opacity: 0.7;
}

/* PAGINACIÓN */

.paginacion {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
}

.paginacion p {
    font-size: 14px;
    color: var(--color-gray-text);
}

.paginacion-botones {
    display: flex;
    gap: 6px;
}

.paginacion-botones button {
    padding: 6px 12px;
    border-radius: 6px;
    border: 1px solid var(--color-light-bg);
    background: var(--color-light-bg);
    cursor: pointer;
    transition: background .2s;
}

.paginacion-botones button:hover {
    background: #e5e7eb;
}

.paginacion-botones .activo {
    background-color: var(--primary-blue);
    color: white;
}

.paginacion-botones button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/pages/Clientes/Clientes.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;IACI,kCAAkC;IAClC,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,kCAAkC;;AAEtC;;AAEA,SAAS;AACT;IACI,aAAa;IACb,SAAO;IACP,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,mBAAmB;;IAEnB,0BAA0B;;IAE1B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;AAC1C;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,sCAAsC;IACtC,iCAAiC;IACjC,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,iCAAiC;IACjC,4CAA4C;AAChD;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,kBAAkB;IAClB,iCAAiC;IACjC,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;AACrC;;AAEA,UAAU;;AAEV;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA,gBAAgB;AAChB;IACI,gCAAgC;IAChC,0BAA0B;IAC1B,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;;;AAIA,sBAAsB;AACtB;IACI,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA,eAAe;;AAEf;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,uCAAuC;IACvC,iCAAiC;IACjC,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":["/* CONTENEDOR GENERAL */\r\n\r\n.clientes-container {\r\n    background-color: var(--app-fondo);\r\n    color: var(--texto-principal);\r\n    min-height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    font-family: var(--font-principal);\r\n\r\n}\r\n\r\n/* MAIN */\r\n.clientes-main {\r\n    padding: 32px;\r\n    flex: 1;\r\n    margin: 0px 80px;\r\n}\r\n\r\n/* FILTROS */\r\n.toolbar-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    flex-wrap: wrap; \r\n    gap: 20px;       \r\n    margin-bottom: 25px;\r\n    \r\n    background: var(--bg-card); \r\n    \r\n    padding: 20px;\r\n    border-radius: 12px;\r\n    box-shadow: var(--sombra-card);\r\n    border: 1px solid var(--color-borders);\r\n}\r\n\r\n/* Search Wrapper */\r\n.search-wrapper {\r\n    position: relative;\r\n    flex: 1; \r\n    min-width: 280px;\r\n}\r\n\r\n.search-icon {\r\n    position: absolute;\r\n    left: 12px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    color: var(--color-gray-text);\r\n    font-size: 1.2rem;\r\n}\r\n\r\n.search-input {\r\n    width: 100%; \r\n    padding: 10px 12px 10px 45px;\r\n    border: 1px solid var(--color-borders); \r\n    background-color: var(--bg-input); \r\n    color: var(--texto-principal);\r\n    border-radius: 8px;\r\n    font-size: 14px; \r\n    outline: none;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.search-input:focus {\r\n    border-color: var(--primary-blue);\r\n    box-shadow: 0 0 0 3px rgba(67, 56, 202, 0.1);\r\n}\r\n\r\n/* Filter - Order Wrapper */\r\n.filter-order-wrapper {\r\n    display: flex;\r\n    gap: 20px;\r\n    flex-wrap: wrap;\r\n    flex-shrink: 0; \r\n}\r\n\r\n.filter-select {\r\n    padding: 10px 12px;\r\n    border: 1px solid var(--color-borders);\r\n    border-radius: 8px;\r\n    background-color: var(--bg-input);\r\n    color: var(--texto-principal);\r\n    cursor: pointer;\r\n    outline: none;\r\n    font-size: 14px;\r\n    width: auto; \r\n    min-width: 150px; \r\n    appearance: none;\r\n}\r\n\r\n.filter-select:focus {\r\n    border-color: var(--primary-blue);\r\n}\r\n\r\n/* TABLA */\r\n\r\n.tabla-container {\r\n    border-radius: 12px;\r\n    box-shadow: var(--sombra-card);\r\n    overflow: hidden;\r\n}\r\n.clientes-tabla tr {\r\n    background-color: var(--bg-card);\r\n}\r\n.clientes-tabla {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    table-layout: fixed;\r\n}\r\n\r\n.clientes-tabla th,\r\n.clientes-tabla td {\r\n    text-align: left;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    padding: 12px 16px;\r\n    border-bottom: 1px solid var(--color-light-bg);\r\n}\r\n\r\n/* Encabezados */\r\n.clientes-tabla th {\r\n    background-color: var(--bg-card);\r\n    color: var(--primary-blue);\r\n    text-transform: uppercase;\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n}\r\n\r\n\r\n\r\n/* Botones de acción */\r\n.accion-boton {\r\n    background: none;\r\n    border: none;\r\n    color: var(--primary-blue);\r\n    cursor: pointer;\r\n    font-size: 20px;\r\n    transition: opacity .2s;\r\n}\r\n\r\n.accion-boton:hover {\r\n    opacity: 0.7;\r\n}\r\n\r\n/* PAGINACIÓN */\r\n\r\n.paginacion {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-top: 16px;\r\n}\r\n\r\n.paginacion p {\r\n    font-size: 14px;\r\n    color: var(--color-gray-text);\r\n}\r\n\r\n.paginacion-botones {\r\n    display: flex;\r\n    gap: 6px;\r\n}\r\n\r\n.paginacion-botones button {\r\n    padding: 6px 12px;\r\n    border-radius: 6px;\r\n    border: 1px solid var(--color-light-bg);\r\n    background: var(--color-light-bg);\r\n    cursor: pointer;\r\n    transition: background .2s;\r\n}\r\n\r\n.paginacion-botones button:hover {\r\n    background: #e5e7eb;\r\n}\r\n\r\n.paginacion-botones .activo {\r\n    background-color: var(--primary-blue);\r\n    color: white;\r\n}\r\n\r\n.paginacion-botones button:disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
